import React, {Component} from "react";

export default class CollectionTableObj extends Component {
    constructor(props) {
        super(props);
    }


    getColumns = () => {
        const collectionObj = this.props.collectionObj;
        const {doctorName} = this.props;
        if (Object.keys(collectionObj).length) {
            let totalAmount = 0;
            let ReturnArray = [];
            Object.keys(collectionObj).forEach((category) => {
                let categoryTotal = 0;
                const categoryName = category;
                let categoryIndex = 0;
                collectionObj[category].forEach((collection, i) => {
                    categoryTotal += collection.Amount;
                    totalAmount += collection.Amount;
                    if (i === 0) {
                        categoryIndex = i;
                    }
                })
                ReturnArray.push(
                    <tr key={`${categoryIndex}-1`}>
                        <td>{doctorName}</td>
                        <td>{categoryName}</td>
                        <td>$ {categoryTotal.toFixed(2)}</td>
                    </tr>
                );
            })
            ReturnArray.push(
                <tr key={'total'}>
                    <td colSpan="2"><strong>Total</strong></td>
                    <td><strong>$ {totalAmount.toFixed(2)}</strong></td>
                </tr>
            );
            return ReturnArray;

        } else {
            return (
                <tbody>
                <tr>
                    <td colSpan="3">No Record Found</td>
                </tr>
                </tbody>
            );
        }
    }

    render() {

        return (
            <table className="table table-striped fixed compact table-hover my-0 TableHeaderFixed">
                <thead>
                <tr>
                    <th>
                        <div> Dr Name</div>
                    </th>
                    <th>
                        <div> Category</div>
                    </th>
                    <th>
                        <div> Amount</div>
                    </th>
                </tr>
                </thead>
                <tbody>
                {this.getColumns()}
                </tbody>
            </table>
        );
    }
}